import React from 'react';
import { PropTypes } from 'prop-types';
import classnames from 'classnames';

import CircleCheckMarkIcon from '@icons/CircleCheckMarkIcon';
import CircleDangerIcon from '@icons/CircleDangerIcon';
import LoadingSpinnerIcon from '@icons/LoadingSpinnerIcon';
import { LinkSmall } from '@styled';
import Circle from '../Circle';

/**
 * This Component is intended for actions that need a status displayed to the user
 * but it does not need to submit a form.
 */

const LinkBlueWithStatus = ({
    children,
    onClick,
    style = {},
    isDisabled = false,
    isSubmitting = false,
    isSuccessful = false,
    isError = false,
    submittingText = 'Saving...',
    errorText = 'Error saving.',
    successText = 'Success!',
}) => {
    const handleOnClick = e => {
        if (onClick) {
            e.preventDefault();
            onClick();
        }
    };

    const classes = classnames(
        'd-inline-block',
        'align-items-center',
        { isSubmitting, isSuccessful, isError },
        { disabled: isDisabled }
    );

    return (
        <LinkSmall
            onClick={handleOnClick}
            className={classes}
            style={{ ...style, zIndex: isSubmitting ? '2' : 'auto' }}
            disabled={isSubmitting || isSuccessful || isError}
        >
            <span className="fade-in-fast d-flex align-items-center justify-content-center">
                {isSubmitting && (
                    <>
                        <LoadingSpinnerIcon size="1x" fill="#545454" />
                        <span className="ml-2">{submittingText}</span>
                    </>
                )}
                {isSuccessful && (
                    <>
                        <Circle size={25} status="success">
                            <CircleCheckMarkIcon />
                        </Circle>
                        <span className="ml-2">{successText}</span>
                    </>
                )}
                {isError && (
                    <>
                        <Circle size={25} status="error">
                            <CircleDangerIcon />
                        </Circle>
                        <span className="ml-2">{errorText}</span>
                    </>
                )}
            </span>
            {!isSubmitting && !isSuccessful && !isError && children}
        </LinkSmall>
    );
};

LinkBlueWithStatus.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    onClick: PropTypes.func,
    isDisabled: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    isSuccessful: PropTypes.bool,
    isError: PropTypes.bool,
    style: PropTypes.object,
    submittingText: PropTypes.string,
    errorText: PropTypes.string,
    successText: PropTypes.string,
};

export default LinkBlueWithStatus;
